define([
	"dojo/_base/declare"
], function(declare) {
	
	return declare(Error, {
		constructor: function(/*String*/s) {
			this.message = s;
		}
	});
});